/*
 * Copyright (c) 2023. Collabro Limited
 */
import React from "react";
import { baseURL } from "../../api";
import { PersonnelModel } from "RosterData";
import { Avatar } from "@mui/material";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";

interface PersonnelAvatarProps {
  personnelData: PersonnelModel;
}

const PersonnelAvatar = (props: PersonnelAvatarProps) => {
  const imageUrl = `${baseURL}/personnel/avatar?personnelId=${props.personnelData.personnelId}`;
  const placeholderUrl = `${baseURL}/personnel/avatar/temp`;

  return (
    <Avatar
      sx={{
        width: 32,
        height: 32,
      }}
    >
      <LazyLoadImage
        src={imageUrl}
        placeholderSrc={placeholderUrl}
        effect="blur"
        width="100%"
        height="100%"
      />
    </Avatar>
  );
};

export default PersonnelAvatar;
